<!-- Desktop -->
@if (shoppingCartPage) {
  <div class="cart d-none d-xl-flex">
    <div>
      <img [src]="shoppingCartPage.hero_image" alt="Shopping Cart Hero Image">
    </div>
    <div class="w-100">
      <div class="close">
        <mat-icon [mat-dialog-close]="true" class="material-symbols-outlined">close</mat-icon>
      </div>
      <div class="pt-5 px-5">
        <div class="d-flex justify-content-center divider-bold">
          <h2 mat-dialog-title>My Cart</h2>
        </div>
        <mat-dialog-content class="cart-items my-3">
          @for (line of (cart$ | async)?.lines; track line) {
            <ng-container class="my-3">
              <div class="row divider py-3">
                <div class="col-4 col-xxl-3 d-flex align-items-center">
                  <img class="product-img" [src]="line.variant.image.url" [alt]="line.variant.productTitle">
                </div>
                <div class="col-8 col-xxl-9 d-flex flex-column">
                  <div class="d-flex flex-column align-items-start">
                    <h3>{{line.variant.productTitle}}</h3>
                    @if (line.sellingPlanAllocation) {
                      <h5>{{line.variant.variantTitle}} - {{line.sellingPlanAllocation.name}}</h5>
                    } @else {
                      <h5>{{line.variant.variantTitle}}</h5>
                    }
                  </div>
                  <div class="d-flex flex-row justify-content-between">
                    <div class="d-flex align-items-center justify-content-evenly h-100">
                      <button mat-mini-fab color="primary" (click)="removeItem(line)">
                        <mat-icon class="material-symbols-small">remove</mat-icon>
                      </button>
                      <span class="item-count">{{line.variant.amountInCart}}</span>
                      <div [matTooltip]="line.variant.inventory > line.variant.amountInCart ? '' : 'No more in stock'">
                        <button
                          mat-mini-fab color="primary"
                          (click)="addItem(line)"
                          [disabled]="line.variant.inventory <= line.variant.amountInCart"
                          >
                          <mat-icon class="material-symbols-small">add</mat-icon>
                        </button>
                      </div>
                    </div>
                    <div class="col-2 d-flex align-items-center justify-content-center">
                      @if (line.sellingPlanAllocation) {
                        <h3>${{(line.sellingPlanAllocation.checkoutChargeAmount * line.variant.amountInCart).toFixed(2)}}</h3>
                      } @else {
                        <h3>${{(line.variant.price * line.variant.amountInCart).toFixed(2)}}</h3>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          }
          @if ((cart$ | async)?.lines?.length === 0) {
            <div class="d-flex flex-column justify-content-center align-items-center w-100 h-100">
              <h3>Looks like your cart is empty.</h3>
              <a href="/">
                <h5 class="mt-3">Can't find what your looking for?</h5>
              </a>
            </div>
          }
        </mat-dialog-content>
        <div class="d-flex w-100 justify-content-between pt-3 checkout-border">
          <h3>Subtotal</h3>
          <h3>${{(cart$ | async)?.cost?.subtotalAmount?.toFixed(2)}}</h3>
        </div>
        <div class="d-flex justify-content-between align-items-end h-100 w-100 action-buttons py-4">
          <button [mat-dialog-close]="true" class="secondary">
            Continue Shopping
          </button>
          <button class="accent checkout-btn" (click)="checkout()" [disabled]="(cart$ | async)?.lines === undefined || (cart$ | async)?.lines ?.length === 0">
            @if (!(spinner$ | async)?.show) {
              Checkout
            }
            @if ((spinner$ | async)?.show) {
              <span class="spinner">
                <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise" [fullScreen]="false"></ngx-spinner>
              </span>
            }
          </button>
        </div>
      </div>
    </div>
  </div>
}
<!-- Mobile -->
@if (shoppingCartPage) {
  <div  class="cart cart-mobile d-block d-xl-none">
    <div class="d-flex flex-row align-items-center w-100 dialog-title">
      <div class="d-flex justify-content-center w-100">
        <h2 class="small-title mb-0" mat-dialog-title>My Cart</h2>
      </div>
      <div class="close close-mobile">
        <mat-icon [mat-dialog-close]="true" class="material-symbols-outlined">close</mat-icon>
      </div>
    </div>
    <div class="d-flex flex-column align-items-center w-100 py-2 checkout-border mobile-checkout">
      <!-- <button [mat-dialog-close]="true" class="secondary w-75">
      Continue Shopping
    </button> -->
    <div class="d-flex w-100 justify-content-center my-2">
      <h3>Subtotal:&nbsp;&nbsp;</h3>
      <h3>${{(cart$ | async)?.cost?.subtotalAmount?.toFixed(2)}}</h3>
    </div>
    <button class="accent checkout-btn-mobile w-75 mb-2" (click)="checkout()" [disabled]="(cart$ | async)?.lines === undefined || (cart$ | async)?.lines?.length === 0">
      @if (!(spinner$ | async)?.show) {
        Checkout
      }
      @if ((spinner$ | async)?.show) {
        <div class="d-flex justify-content-center w-100">
          <span class="spinner">
            <ngx-spinner bdColor="rgba(255, 255, 255, 0)" size="small" color="#fff" type="ball-spin-clockwise" [fullScreen]="false"></ngx-spinner>
          </span>
        </div>
      }
    </button>
  </div>
  <mat-dialog-content class="p-0">
    @for (line of (cart$ | async)?.lines; track line) {
      <div class="divider py-3 px-3">
        <div class="row d-flex align-items-center mb-3">
          <div class="col-4 col-sm-4 col-md-3">
            <div class="d-flex justify-content-center">
              <img class="product-img" [src]="line.variant.image.url" [alt]="line.variant.productTitle">
            </div>
          </div>
          <div class="col-8 col-sm-8  col-md-9">
            <h3>{{line.variant.productTitle}}</h3>
            @if (line.sellingPlanAllocation) {
              <h5>{{line.variant.variantTitle}} - {{line.sellingPlanAllocation.name}}</h5>
            } @else {
              <h5>{{line.variant.variantTitle}}</h5>
            }
          </div>
        </div>
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex align-items-center justify-content-evenly">
            <button mat-mini-fab color="primary" (click)="removeItem(line)" class="small-fab">
              <mat-icon class="material-symbols-extra-small">remove</mat-icon>
            </button>
            <span class="item-count">{{line.variant.amountInCart}}</span>
            <div [matTooltip]="line.variant.inventory > line.variant.amountInCart ? '' : 'No more in stock'">
              <button
                mat-mini-fab
                color="primary"
                (click)="addItem(line)"
                class="small-fab"
                [disabled]="line.variant.inventory <= line.variant.amountInCart"
                >
                <mat-icon class="material-symbols-extra-small">add</mat-icon>
              </button>
            </div>
          </div>
          <div class="d-flex align-items-center justify-content-center">
            @if (line.sellingPlanAllocation) {
              <h3>${{(line.sellingPlanAllocation.checkoutChargeAmount * line.variant.amountInCart).toFixed(2)}}</h3>
            } @else {
              <h3>${{(line.variant.price * line.variant.amountInCart).toFixed(2)}}</h3>
            }
          </div>
        </div>
      </div>
    }
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    @if ((cart$ | async)?.lines?.length === 0) {
      <div class="d-flex flex-column justify-content-center align-items-center my-5 w-100 h-100">
        <h3>Looks like your cart is empty.</h3>
    </div>
  }
</mat-dialog-content>
</div>
}
